// extracted by mini-css-extract-plugin
export default {"modalBody":"modalBody-vXy3g","tabs":"tabs-Fei3i"};